<template>
  <div class="table-responsive insight-modal__table d-none d-lg-block">
    <table class="table table-bordered mb-0">
      <thead>
        <tr>
          <th class="align-middle" scope="col">Name</th>
          <th class="align-middle" scope="col">Category</th>
          <th class="align-middle" scope="col">
            Date
            <IconCaretDownFill v-if="selectedSortValue == 'asc'" class="mb-1" />
            <IconCaretUpFill v-else class="mb-1" />
          </th>
          <th class="align-middle" scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in insightModalStore.items" :key="item.id">
          <td class="align-middle">
            <div class="insight-modal__table__name">
              <NuxtImg v-if="item.imgSrc" :src="item.imgSrc" />
              <span>{{ item.title }}</span>
            </div>
          </td>
          <td class="align-middle">
            <div class="insight-modal__table__category">
              <p>{{ item.insightCategory[0] }}</p>
            </div>
          </td>
          <td class="align-middle">
            <div class="insight-modal__table__date">
              <p>{{ prettyDate2Digit(new Date(item.publishingDate).toISOString()) }}</p>
            </div>
          </td>
          <td class="align-middle">
            <button
              :class="`btn btn-manatt-black w-100 table-item-btn`"
              @click="navigate(item.id)"
            >
              Read More
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="insight-modal__list d-lg-none">
    <ul>
      <li v-for="item in insightModalStore.items" :key="item.id">
        <div class="insight-modal__list__item card" @click="navigate(item.id)">
          <NuxtImg v-if="item.imgSrc" :src="item.imgSrc" />
          <div class="insight-modal__list__item__text">
            <div class="insight-modal__list__item__text__top-row">
              <span>{{ item.insightCategory[0] }}</span>
              <span>{{ prettyDate2Digit(new Date(item.publishingDate).toISOString()) }}</span>
            </div>
            <div class="insight-modal__list__item__text__bottom-row">
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useInsightModalStore } from '~/stores/modals/insight-modal'

const pageStore = usePageStore()
const insightModalStore = useInsightModalStore()
const { selectedSortValue } = storeToRefs(insightModalStore)

const navigate = async (itemId: string) => {
  document.body.classList.remove('modal-open')

  const url = await pageStore.getUrlByItemId(itemId)
  navigateTo(url)
}
</script>
